import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [{
    path: "/",
    name: "indexA",
    component: () => import('../pages/index/index.vue'),
    children: [
    //   {
    //   path: "/common/:themeColor",
    //   name: "indexA_tab1",
    //   component: () => import('../pages/tab1/index.vue'),
    // },
    // {
    //   path: "/common",
    //   name: "indexA_tab1",
    //   component: () => import('../pages/tab1/index.vue'),
    // },
    {
      path: "/skill",
      name: "indexA_tab2",
      component: () => import('../pages/tab2/index.vue'),
    },{
      path: "/video",
      name: "indexA_tab3",
      component: () => import('../pages/tab3/index.vue'),
    },{
      path: "/log",
      name: "indexA_tab4",
      component: () => import('../pages/tab4/index.vue'),
    },{
      path: "/exam",
      name: "indexA_tab5",
      component: () => import('../pages/tab5/index.vue'),
    },{
      path: "/funVideo",
      name: "indexA_tab6",
      component: () => import('../pages/tab6/index.vue'),
    },{
      path: "/common/:themeColor?",
      name: "indexA_question",
      component: () => import('../pages/question/index.vue'),
    },{
      path: "question",
      name: "indexA_question",
      component: () => import('../pages/question/index.vue'),
    }
  ]
  },{
    path: "/version",
    name: "indexA_version",
    component: () => import('../pages/version/index.vue'),
  },{
    path: "/iframe/version",
    name: "indexA_iframe_version",
    component: () => import('../pages/webView/version.vue'),
  }]
})

export default router
